export default "__VITE_ASSET__klrZWkVX__"